import Reveal from '@/components/feature/Reveal';
import SectionHeading from './SectionHeading';
import { noteGroups } from '@/mocks/guide';

const toneStyles: Record<string, { wrap: string; icon: string; title: string; dot: string }> = {
  secondary: {
    wrap: 'bg-secondary-50 border-secondary-200',
    icon: 'bg-secondary-100 text-secondary-700',
    title: 'text-secondary-900',
    dot: 'ri-check-line text-secondary-600',
  },
  accent: {
    wrap: 'bg-accent-50 border-accent-200',
    icon: 'bg-accent-100 text-accent-700',
    title: 'text-accent-900',
    dot: 'ri-close-line text-accent-600',
  },
};

export default function NotesSection() {
  return (
    <section id="notes" className="w-full bg-background-100 py-16 md:py-24 border-y border-background-200">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          kicker="NOTES"
          title="投稿注意事项：这些细节最容易被忽略"
          desc="规范之外，还有一些会影响线索走向的细节。下面把该做的和不该做的分开列清楚，投稿前对照一遍基本不会踩坑。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {noteGroups.map((group, index) => {
            const tone = toneStyles[group.tone] ?? toneStyles.secondary;
            return (
              <Reveal key={group.title} delay={index * 100}>
                <div className={`h-full p-6 md:p-7 rounded-lg border ${tone.wrap}`}>
                  <div className="flex items-center gap-3">
                    <span className={`w-11 h-11 flex items-center justify-center rounded-md ${tone.icon}`}>
                      <i className={`${group.icon} text-2xl`} aria-hidden="true" />
                    </span>
                    <h3 className={`font-heading font-semibold text-lg md:text-xl ${tone.title}`}>{group.title}</h3>
                  </div>
                  <ul className="mt-5 space-y-3.5">
                    {group.items.map((item) => (
                      <li key={item} className="flex gap-3 text-sm text-foreground-700 leading-relaxed">
                        <i className={`${tone.dot} mt-1 shrink-0`} aria-hidden="true" />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={80}>
          <div className="mt-6 md:mt-8 flex flex-col md:flex-row md:items-center gap-4 md:gap-6 p-6 rounded-lg bg-primary-100 border border-primary-200">
            <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-500 text-background-50 shrink-0">
              <i className="ri-shield-check-line text-2xl" aria-hidden="true" />
            </span>
            <div>
              <h3 className="font-heading font-semibold text-base md:text-lg text-primary-900">关于隐私与法律边界</h3>
              <p className="mt-1 text-sm text-primary-900/80 leading-relaxed">
                请只提交你确有依据、且不侵犯他人合法权益的内容。涉及正在进行的司法程序、未成年人信息或商业秘密时，请在稿件中明确标注，编辑会在核实后决定可公开范围。
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}